import { render, staticRenderFns } from "./FavoritesStar.vue?vue&type=template&id=e9c60702&"
import script from "./FavoritesStar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FavoritesStar.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports